<template>
    <div class="product__island bg-shade-light py-prj px-prj2 px-3@large">
        <div class="row">
            <div class="small-12 medium-4 column d-flex py-prj py-2@large"> 
                <div class="bg-shade d-flex flex-child-auto align-items-center">
                    <figure class="bg-shade product__figure embed-responsive embed-responsive-1/1">
                        <img :src="imgurl" class="object-fit-contain" :alt="globalConfig.productimg_metatitle" />
                    </figure>
                </div>
            </div>
            <div class="small-12 medium-8 column d-flex">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['globalConfig'],
        computed: {
            imgurl() { return this.globalConfig.productImageUrl},
        }
    }
</script>